export default __webpack_public_path__ + "static/media/dc-green.01c54ee1.jpg";